import React, { useState, useEffect, useMemo } from "react";
import house from "../../PicesForPages/house.png";
import calendar from "../../PicesForPages/calendar-5.png";
import smartphoneHand from "../../PicesForPages/smartphone-7.png";
import smartphoneVoice from "../../PicesForPages/smartphone-6.png";
import officeWorkLaptop from "../../PicesForPages/loan-office-work-table.jpg";
import loseIcon from "../../PicesForPages/lose.png";
import coinHand from "../../PicesForPages/coinHand.png";
import piggyBank from "../../PicesForPages/piggy-bank.png";
import houseMoney from "../../PicesForPages/houseMoney.png";
import rollerStick from "../../PicesForPages/066-roller.png";
import CreditCard from "../../PicesForPages/cc.png";
import time2 from "../../PicesForPages/time2.png";
import payMoney from "../../PicesForPages/pay.png";
import thumbsUp from "../../PicesForPages/thumbsUp.png";
import news from "../../PicesForPages/news.jpg";
import MortgageCalculator from "../CalculatorAndChart/mortgageCalculator";
// import calcSmall from '../../PicesForPages/calc-small.jpg';
import ChatBotPurchase from "../Form/ChatBotPurchase";
import ChatBotRefinance from "../Form//ChatBotRefinance";
import HomePageMonthlyPayment from "../CalculatorAndChart/homePageMonthlyPayment";
import YourTeamMembers from "../StaffDetails/teamMembers";
import ClientReview from "../Client_Review/clientReview";
import BlogPostInAPage from "../blogPages/BlogPagePosts/blogPostInAPage";

import { Link } from "react-router-dom";

function Home() {
  const texts = useMemo(
    () => [
      "Reduce Monthly Payments",
      "Secure Lower Rates",
      "Own Your First Home",
      "Turn Dreams Into Homes",
      "Leverage Your Equity",
    ],
    [],
  );

  const [currentText, setCurrentText] = useState("");
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [activeChatBot, setActiveChatBot] = useState(null); // null, "purchase", or "refinance"
  const typingSpeed = 100;
  const deletingSpeed = 50;

  useEffect(() => {
    const handleTyping = () => {
      const fullText = texts[currentTextIndex];

      if (!isDeleting) {
        setCurrentText((prev) => fullText.substring(0, prev.length + 1));
        if (currentText === fullText) {
          setTimeout(() => setIsDeleting(true), 1000);
        }
      } else {
        setCurrentText((prev) => fullText.substring(0, prev.length - 1));
        if (currentText === "") {
          setIsDeleting(false);
          setCurrentTextIndex((prev) => (prev + 1) % texts.length);
        }
      }
    };

    const typingInterval = setInterval(
      handleTyping,
      isDeleting ? deletingSpeed : typingSpeed,
    );

    return () => clearInterval(typingInterval);
  }, [currentText, isDeleting, texts, currentTextIndex]);

  return (
    <div className="homeParent">
      <div className="homePageFirstImage"></div>
      <div className="homeHelpYouBoxParent">
        <div className="homeHelpYouBox">
          {activeChatBot === null && (
            <>
              <span className="homeHelpYouHeading">
                <span className="homeHelpYouHeadingLeft">
                  Let's Assist You...{" "}
                </span>
                <span className="typingText homeHelpYouHeadingRight">
                  {currentText}
                </span>
              </span>
              <span className="homeHelpYouContent">
                Your goals matter to us, and we’re ready to help you reach them.{" "}
                <br /> Start today with our quick and simple prequalifier!
              </span>
              <span className="homeHelpYouButton">
                <button
                  className="homeHelpYouButtonLeft"
                  onClick={() => setActiveChatBot("purchase")}
                >
                  Purchase
                </button>
                <button
                  className="homeHelpYouButtonRight"
                  onClick={() => setActiveChatBot("refinance")}
                >
                  Refinance
                </button>
              </span>
            </>
          )}

          {activeChatBot === "purchase" && (
            <span className="homeHelpYouChatBot">
              <ChatBotPurchase />
              <button
                className="closebtnChatBot"
                onClick={() => setActiveChatBot(null)}
              >
                X
              </button>
            </span>
          )}

          {activeChatBot === "refinance" && (
            <span className="homeHelpYouChatBot">
              <ChatBotRefinance />
              <button
                className="closebtnChatBot"
                onClick={() => setActiveChatBot(null)}
              >
                X
              </button>
            </span>
          )}
        </div>
      </div>
      <div className="welcomeBoxParent">
        <div className="welcomeBox">
          <span className="welcomeHeading">
            Welcome to <span className="brand_text">VIDHI MORTGAGE LLC</span>
          </span>

          <span className="welcomeContent">
            At <span className="brand_text">VIDHI MORTGAGE LLC</span> we believe
            every client deserves personalized attention—not a one-size-fits-all
            solution. Instead of relying on rigid, industry-standard formulas,
            we take a thoughtful, common-sense approach to help you find the
            loan options that truly fit your financial goals. With access to a
            diverse network of leading lenders and trusted private funding
            sources, we are equipped to serve both traditional and unique
            financing needs.
          </span>

          <span className="welcomeContent">
            Backed by relationships with over 100 investors, we offer highly
            competitive rates across a wide range of loan programs. From 30, 20,
            15, and 10-year fixed mortgages to adjustable-rate options, as well
            as Conventional, Jumbo, VA, Home Equity, and Commercial loans—we’ve
            got you covered. Whether your situation involves full documentation,
            alternative documentation, investment properties, or multi-family
            financing, we deliver tailored solutions designed specifically for
            you.
          </span>
        </div>
      </div>
      <ClientReview />

      <BlogPostInAPage />

      <div className="purchasingBoxParent">
        <div className="purchasingBox">
          <span className="purchasingHeading">Purchasing</span>
          <span className="purchasingContent">
            Delivering trusted real estate financing with solutions for every
            borrower.
          </span>
          <Link to="/purchase" className="purchasingBox_Link">
            <span className="purchasingButton">CLICK HERE FOR MORE</span>
          </Link>
        </div>
      </div>

      <MortgageCalculator />

      <div className="advantageBoxParent">
        <div className="advantageBox">
          <div className="advantageHeading">
            The <span className="brand_text">VIDHI MORTGAGE LLC </span>
            Advantage
          </div>
          <div className="advantageContentBoxParent">
            <span className="advantageContentBox">
              <span className="advantageContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={house}
                  alt="house"
                />
              </span>
              <span className="advantageContentBoxHeading">
                Local Expertise
              </span>
              <span className="advantageContentBoxContent">
                As a proud part of your community, we offer in-depth knowledge
                of the local market and neighborhoods—delivering insights no
                algorithm can match.
              </span>
            </span>
            <span className="advantageContentBox">
              <span className="advantageContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={calendar}
                  alt="calender"
                />
              </span>
              <span className="advantageContentBoxHeading">
                Fast & Efficient Closings
              </span>
              <span className="advantageContentBoxContent">
                We prioritize speed without compromising quality, ensuring your
                loan is processed quickly while expertly navigating any
                challenges along the way.
              </span>
            </span>
            <span className="advantageContentBox">
              <span className="advantageContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={smartphoneHand}
                  alt="smartphoneHand"
                />
              </span>
              <span className="advantageContentBoxHeading">
                Unmatched Client Support
              </span>
              <span className="advantageContentBoxContent">
                From advanced digital tools like secure mobile uploads to
                personalized, one-on-one assistance, we provide a seamless and
                supportive experience at every step.
              </span>
            </span>
            <span className="advantageContentBox">
              <span className="advantageContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={smartphoneVoice}
                  alt="smartphoneVoice"
                />
              </span>
              <span className="advantageContentBoxHeading">
                Driven by Innovation
              </span>
              <span className="advantageContentBoxContent">
                We combine modern technology with a human touch—offering
                convenient, secure solutions while remaining accessible for
                clients who value personal guidance.
              </span>
            </span>
          </div>
        </div>
      </div>

      <YourTeamMembers />

      <div className="addressBoxParent">
        <div className="addressBox">
          <div className="addressHeading">
            <span className="brand_text">VIDHI MORTGAGE LLC</span> Location
            Details
          </div>
          <div className="addressMapDetails">
            <iframe
              title="Vidhi Mortgage Office Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3047.083140541334!2d-83.0162237!3d40.2072135!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8838f11646f69bef%3A0x58adb357891a0cfa!2s5714%20Dorrington%20St%2C%20Lewis%20Center%2C%20OH%2043035%2C%20USA!5e0!3m2!1sen!2sin!4v1774413767335!5m2!1sen!2sin"
              width="700"
              height="450"
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
            <span className="addressDetails">
              <span className="addressDetailsTop">
                <span className="addressDetailsTopHeading">Contact Us:</span>
                <span>Email:contact@vidhimortgage.com</span>
                <span>Phone: (614) 397-1676</span>
                <span>
                  5714 Dorrington St,
                  <br />
                  Lewis Center OH 43035
                </span>
              </span>
              <span className="addressDetailsBottom">
                <span className="addressDetailsBottomHeading">
                  Office Hours:
                </span>
                <span>Monday-Friday: 9am to 6pm</span>
                <span>Saturday: 10am to 2pm</span>
                <span>Sunday: Closed</span>
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="refinanceBoxParent">
        <div className="refinanceBox">
          <div className="refinanceContentBox">
            <span className="refinanceContentBoxHeading">Refinance</span>
            <span className="refinanceContentBoxContent">
              Take control of your future with a fixed-rate mortgage designed
              for long-term security, replacing your current ARM.
            </span>
            <Link to="/refinancing" className="purchasingBox_Link">
              <span className="refinanceContentBoxButton">
                CLICK HERE FOR MORE
              </span>
            </Link>
          </div>
          <span className="refinanceSpanImage">
            <img
              fetchPriority="high"
              loading="eager"
              src={officeWorkLaptop}
              alt="officeWorkLaptop"
            />
          </span>
        </div>
      </div>
      <div className="reHistoricalBoxParent">
        <div className="reHistoricalBox">
          <span className="reHistoricalHeading">
            Refinance at Unbeatable Low Rates!
          </span>
          <div className="reHistoricalContentBoxParent">
            <div className="reHistoricalContentBox">
              <span className="reHistoricalContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={loseIcon}
                  alt="loseIcon"
                />
              </span>
              <span className="reHistoricalContentBoxHeading">
                Lower Monthly Payment
              </span>
              <span className="reHistoricalContentBoxContent">
                Take advantage of today’s low rates and enjoy reduced payments
                with greater financial comfort.
              </span>
              <b>Ideal For</b>
              <span className="reHistoricalContentBoxBottomParent">
                <span className="reHistoricalContentBoxBottom">
                  <span className="reHistoricalContentBoxBottomSpanImage">
                    <img
                      fetchPriority="high"
                      loading="eager"
                      src={coinHand}
                      alt="coinHand"
                    />
                  </span>
                  <span className="reHistoricalContentBoxBottomText">
                    Extra Cash Flow
                  </span>
                </span>
                <span className="reHistoricalContentBoxBottom">
                  <span className="reHistoricalContentBoxBottomSpanImage">
                    <img
                      fetchPriority="high"
                      loading="eager"
                      src={piggyBank}
                      alt="piggyBank"
                    />
                  </span>
                  <span className="reHistoricalContentBoxBottomText">
                    Retirement Savings
                  </span>
                </span>
              </span>
              <a
                href="https://vidhimortgage.my1003app.com/"
                className="historically_aTag reHistoricalContentBoxButton"
              >
                Lowering My Payment
              </a>
            </div>
            <div className="reHistoricalContentBox">
              <span className="reHistoricalContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={houseMoney}
                  alt="houseMoney"
                />
              </span>
              <span className="reHistoricalContentBoxHeading">
                Get Cash Out
              </span>
              <span className="reHistoricalContentBoxContent">
                Turn your home’s value into cash—use it for what matters most.
              </span>
              <b>Perfect For</b>
              <span className="reHistoricalContentBoxBottomParent">
                <span className="reHistoricalContentBoxBottom">
                  <span className="reHistoricalContentBoxBottomSpanImage">
                    <img
                      fetchPriority="high"
                      loading="eager"
                      src={rollerStick}
                      alt="rollerStick"
                    />
                  </span>
                  <span className="reHistoricalContentBoxBottomText">
                    Home Improvements
                  </span>
                </span>
                <span className="reHistoricalContentBoxBottom">
                  <span className="reHistoricalContentBoxBottomSpanImage">
                    <img
                      fetchPriority="high"
                      loading="eager"
                      src={CreditCard}
                      alt="CreditCard"
                    />
                  </span>
                  <span className="reHistoricalContentBoxBottomText">
                    Paying Off High-Interest Debt
                  </span>
                </span>
              </span>
              <a
                href="https://vidhimortgage.my1003app.com/"
                className="historically_aTag reHistoricalContentBoxButton"
              >
                Utilizing My Equity
              </a>
            </div>
            <div className="reHistoricalContentBox">
              <span className="reHistoricalContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={time2}
                  alt="time2"
                />
              </span>
              <span className="reHistoricalContentBoxHeading">
                Shorten Your Loan Term
              </span>
              <span className="reHistoricalContentBoxContent">
                Switch to a shorter-term loan and build equity while saving on
                interest.
              </span>
              <b>Great For</b>
              <span className="reHistoricalContentBoxBottomParent">
                <span className="reHistoricalContentBoxBottom">
                  <span className="reHistoricalContentBoxBottomSpanImage">
                    <img
                      fetchPriority="high"
                      loading="eager"
                      src={payMoney}
                      alt="payMoney"
                    />
                  </span>
                  <span className="reHistoricalContentBoxBottomText">
                    Lower Interest Costs
                  </span>
                </span>
                <span className="reHistoricalContentBoxBottom">
                  <span className="reHistoricalContentBoxBottomSpanImage">
                    <img
                      fetchPriority="high"
                      loading="eager"
                      src={thumbsUp}
                      alt="thumbsUp"
                    />
                  </span>
                  <span className="reHistoricalContentBoxBottomText">
                    Faster Homeownership
                  </span>
                </span>
              </span>
              <a
                href="https://vidhimortgage.my1003app.com/"
                className="historically_aTag reHistoricalContentBoxButton"
              >
                Reducing My Loan Term
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="purchasingBoxParent purchasingBoxParent00">
        <div className="purchasingBox">
          <span className="purchasingHeading">Apply Now</span>
          <span className="purchasingContent">
            Begin your journey with our fast, hassle-free online application.
          </span>
          <Link to="/purchase" className="purchasingBox_Link">
            <span className="purchasingButton">CLICK HERE FOR MORE</span>
          </Link>
        </div>
      </div>
      <div className="latestNewsBoxParent">
        <div className="latestNewsBox">
          <span className="latestNewsSpanImage">
            <img fetchPriority="high" loading="eager" src={news} alt="news" />
          </span>
          <div className="latestNewContentBox">
            <span className="latestNewHeading">Latest News</span>
            <span className="latestNewContent01">
              Eurozone Bond Markets Intensify Scrutiny on Fiscal Reforms
            </span>
            <span className="latestNewContent02">
              Eurozone government bond investors are increasingly focusing on
              public finance stability, as highlighted by Societe Generale.
              Recent negative outlooks from Moody’s on Belgium and Fitch on
              France underscore growing concerns and signal caution ahead.
            </span>
          </div>
        </div>
      </div>
      <div className="purchasingBoxParent purchasingBoxParent01">
        <div className="purchasingBox purchasingBox01">
          <ul>
            <span className="purchasingHeading purchasingHeading01">
              Market Updates
            </span>
            <li>Simplified Loan Process</li>
            <li>Know Your Borrowing Capacity</li>
            <li>Expert Refinance Review</li>
            <li>Monthly Payment Calculator</li>
            <li>Mortgage Terms Explained</li>
          </ul>
          <div></div>
        </div>
      </div>
      <HomePageMonthlyPayment />
    </div>
  );
}

export default Home;
